
import React from 'react'

const Newsletter = () => {
  return (
    <section className='bg-[#EAE2F4] py-16 flex flex-col justify-center'>
        <h2 className='text-[#312A46] font-semibold text-4xl md:text-[30px] text-center '>Subscribe to our newsletter</h2>
        <p className="text-[#4E4949] text-base text-center md:text-[15px] mt-2 mb-7 ">Be the first to get notifications about the latests school news</p>
        <div className='text-center w-[70%] md:w-[90%] mx-auto'>
            <input className='py-4 pl-2  w-[40%] focus:outline-none md:w-[70%]' type="email" placeholder='Enter email address' /> <button className='bg-[#5146AE] text-white py-4 px-3 w-[20%] md:w-fit font-medium text-base'>Subscribe</button>
        </div>
    </section>
  )
}

export default Newsletter